export const IMAGE_FIELDS = `
  altText
  sourceUrl
`

export const LINK_FIELDS = `
  externalUrl
  label
  target
  type
  url {
    ... on Post {
      uri
    }
    ... on Page {
      uri
    }
    ... on Project {
      uri
    }
  }
`
